import {
  Container,
  Box,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
  Divider,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
// import useStyles from "./styles";

import { useFormContext, Controller } from "react-hook-form";
import { useSharedBookReducer } from "../state";
import { Card } from "../Card";
import { LiabilityCheckbox } from "../LiabilityCheckbox";
import useUser from "../../../lib/useUser";

const SignupCard = ({ onComplete }) => {
  const { user } = useUser();
  const [bookState, dispatch] = useSharedBookReducer();
  const { register, setValue, control } = useFormContext();

  //   const setJoinPeople = (e) => {
  //     dispatch({
  //       type: "MERGE",
  //       payload: {
  //         m: { joinpeople: e.target.value },
  //       },
  //     });
  //   };

  const promoDiscountApplies = (() => {
    if (bookState.promo?.output) {
      switch (bookState.promo.output?.discount) {
        case "percent":
        case "dollars":
        case "setprice":
          return true;
        case "notapply":
          return false;
        default:
          console.error("invalid promoData exists");
          break;
      }
    }
    return false;
  })();

  const handleToggleSkipCard = (e) => {
    dispatch({
      type: "MERGE",
      payload: {
        m: { skip_card: e.target.checked },
      },
    });
  };

  return (
    <>
      <Typography variant="h5" gutterBottom>
        Credit Card and Checkout
      </Typography>

      {user?.roles?.includes("admin") ? (
        <Box sx={{ marginBottom: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={bookState.m.skip_card}
                onChange={handleToggleSkipCard}
              />
            }
            label="Skip Card (Admin only)"
          />
        </Box>
      ) : null}
      <br />
      {bookState.m.skip_card ? null : <Card />}

      <br />
      <Divider />
      <br />
      <div style={{ textAlign: "right" }}>
        <Typography variant="h5">
          Subtotal: {bookState.totals.subtotal}
        </Typography>

        {bookState.promo.details && promoDiscountApplies ? (
          <Typography variant="h6">
            {bookState.promo.details.title}: {bookState.totals.discount}
          </Typography>
        ) : null}
        {bookState.promo.details?.message ? (
          <Typography variant="body2">
            {bookState.promo.details.message}
          </Typography>
        ) : null}

        <Typography variant="h3">
          Your Price: {bookState.totals.total}
        </Typography>

        <Typography variant="caption">
          Fully refundable until 4 hours before lesson start.
          <br />
          $95 charge for late cancelation.
          <br />
          No refunds for no shows.
        </Typography>

        <div>{/* <LiabilityCheckbox /> */}</div>

        <br />
        <br />

        <Button
          variant="contained"
          color="success"
          size="large"
          onClick={bookState.saving ? null : onComplete}
          fullWidth
        >
          {bookState.saving ? "Please wait..." : "Book Lesson"}
        </Button>
      </div>

      {/* <a id="purchase" class="button is-success is-fullwidth" v-on:click="checkout" :disabled="!!submitted">
									<span class="icon">
										<i class="fa fa-credit-card"></i>
									</span>
									<span>Book Lesson</span>
								</a> */}

      {/* 
								<h3 class="title is-5">
									Credit Card Checkout
                </h3>
                
                <Card />

								<br />
								<hr />

								<br />

								<h3 class="title is-4 has-text-right">
									Subtotal: $\{{sub_totalamount}}
								</h3>

								<h3 class="title is-4 has-text-right" v-if="promo.details && promoDiscountApplies">
									<span style="font-weight:normal;">\{{promo.details.title}}: -$\{{discount_totalamount}}</span>
								</h3>
								<h3 class="subtitle is-6 has-text-right" v-if="promoDiscountMessage">
									\{{promoDiscountMessage}}
								</h3>

								<h3 class="title is-3 has-text-right">
									Your Price: $\{{totalamount}}
								</h3>

								<p class="help is-default has-text-right">
									Fully refundable until 4 hours before lesson start.
									<br />
									$95 charge for late cancelation.
									<br />
									No refunds for no shows.
								</p>

								<br />

								<a id="purchase" class="button is-success is-fullwidth" v-on:click="checkout" :disabled="!!submitted">
									<span class="icon">
										<i class="fa fa-credit-card"></i>
									</span>
									<span>Book Lesson</span>
								</a>


       */}
    </>
  );
};

export default SignupCard;
